// extracted by mini-css-extract-plugin
module.exports = {"user":"styles__user___2YSx2","checkboxWrapper":"styles__checkboxWrapper___3wOGr","name":"styles__name___dtEf2"};